import { AVAILABLE_LANGS } from "@typings/globals";

//en
import secondImgMobileEn from "./assets/mobile/2.2_EN.webp";
import secondImgTabletEn from "./assets/tablet/2.2_EN.webp";
import secondImgDesktopEn from "./assets/desktop/2.2_EN.webp";
//de
import secondImgMobileDe from "./assets/mobile/2.2_DE.webp";
import secondImgTabletDe from "./assets/tablet/2.2_DE.webp";
import secondImgDesktopDe from "./assets/desktop/2.2_DE.webp";
//it
import secondImgMobileIt from "./assets/mobile/2.2_IT.webp";
import secondImgTabletIt from "./assets/tablet/2.2_IT.webp";
import secondImgDesktopIt from "./assets/desktop/2.2_IT.webp";
//fr
import secondImgMobileFr from "./assets/mobile/2.2_FR.webp";
import secondImgTabletFr from "./assets/tablet/2.2_FR.webp";
import secondImgDesktopFr from "./assets/desktop/2.2_FR.webp";

export const mobileSecondImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: secondImgMobileDe,
    [AVAILABLE_LANGS.FR]: secondImgMobileFr,
    [AVAILABLE_LANGS.IT]: secondImgMobileIt,
  };

  return language in images ? images[language] : secondImgMobileEn;
};

export const tabletSecondImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: secondImgTabletDe,
    [AVAILABLE_LANGS.FR]: secondImgTabletFr,
    [AVAILABLE_LANGS.IT]: secondImgTabletIt,
  };

  return language in images ? images[language] : secondImgTabletEn;
};

export const desktopSecondImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: secondImgDesktopDe,
    [AVAILABLE_LANGS.FR]: secondImgDesktopFr,
    [AVAILABLE_LANGS.IT]: secondImgDesktopIt,
  };

  return language in images ? images[language] : secondImgDesktopEn;
};
